export { default as Barcode } from './barcode/barcode';
export { default as barcodeValidator } from './barcode/barcode-validator';
